import { Theme } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Switch from "@material-ui/core/Switch"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import React from "react"
import FieldSelect from "Components/Table/FieldSelect"
import ContentTypeSelect from "../WeiboTool/ContentTypeSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useUpdateWeibo } from "./hooks"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme: Theme) => ({
    tagItem: {
        backgroundColor: "#00bcd4",
        padding: `4px 10px`,
        borderRadius: "14px",
        color: "white",
        margin: `10px ${theme.spacing(1)}px`,
        cursor: "pointer",
        boxSizing: "border-box",
        fontSize: 14,
        display: "inline-block",
        fontWeight: "bold",
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
}))

const WeiboUpdate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, disabled,
        dialogData, dateStr, board, text,
        handleChange,
        external, isBusiness, isMine, isPass, isThreeDay,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        handleChangeArticleType,
        handleChangeMicro,
        handleChangeLottery,
        handleChangeContentType,
        editCallback,
    } = useUpdateWeibo()
    return (
        <BoardConfirmModal
            title="修改预约说明"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            editCallback={editCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="内容"
                    value={text}
                    disabled={(isPass || isThreeDay) && isBusiness}
                    onChange={handleChange}
                />
                <Grid item>
                    <FormControl disabled={(isPass || isThreeDay) && isBusiness} className={classes.input}>
                        <InputLabel>内容形式</InputLabel>
                        <ContentTypeSelect initialValue={board.content_type} onChange={handleChangeContentType} />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl disabled={(isPass || isThreeDay) && isBusiness} className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            rowData={{
                                article_type_id: external.articleTypeId,
                            }}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            whereQuery={"where: {hidden: {_eq: false}}"}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl disabled={(isPass || isThreeDay) && isBusiness} component="fieldset" className={classes.input}>
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="抽奖"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isLottery}
                                        onChange={handleChangeLottery}
                                    />
                                }
                                label="抽奖"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="微任务"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isMicro}
                                        onChange={handleChangeMicro}
                                    />
                                }
                                label="微任务"
                                labelPlacement="start"
                            />
                        </FormGroup>
                    </FormControl>
                </Grid>
                <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid>
            </Grid>
            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine ? (
                    <>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
            {
                isBusiness && isThreeDay ? (
                    <>
                        <Grid container justify="flex-start" alignItems="center" className={classes.input}>
                                <Typography color="initial">
                                    注意：3天内的预约不能修改/删除哦~
                                </Typography>
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default WeiboUpdate
